import React from 'react';
import { Result } from 'antd';
import { hot } from 'react-hot-loader';

export default hot(module)(function index() {
	return <Result status="403" title="403" subTitle="Sorry, you are not authorized to access this page." />;
});
